import { render } from "./Areas.vue?vue&type=template&id=26bc57ec&scoped=true"
import script from "./Areas.vue?vue&type=script&scoped=true&lang=js"
export * from "./Areas.vue?vue&type=script&scoped=true&lang=js"

import "./Areas.vue?vue&type=style&index=0&id=26bc57ec&scoped=true&lang=css"

import exportComponent from "D:\\Users\\khale\\CookiesBIS\\Core\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bc57ec"]])

export default __exports__